import React, { useState } from "react";
import BoutonOnglet from "./BoutonOnglet";
import { useNavigate } from "react-router-dom";

const ModalPartielle = ({ devis, totalHT, totalTTC, onConfirm, onValider }) => {
  const [mode, setMode] = useState("percent");
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const handleSubmit = () => {
    const n = Number(value);
    if (!Number.isFinite(n)) return alert("Veuillez entrer un montant/valeur valide.");
    const cb = onConfirm || onValider;          // 👈 compat
    if (cb) {
      cb({ mode, value: n });
    } else {
      const id = devis?.id ?? devis?.devis_id ?? devis?.devisId;
      if (!id) return alert("Devis introuvable.");
      navigate(`/facture-partielle?devisId=${id}&mode=${mode}&value=${n}`);
    }
  };

  const handleAnnuler = () => {
    if (typeof onClose === "function") return onClose();
    navigate(-1);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
      <div className="bg-white p-6 rounded shadow-md w-full max-w-lg">
        <h2 className="text-lg font-semibold mb-4 text-center">
          Générer une <span className="font-bold">facture partielle</span> pour le devis <br />
          <span className="text-blue-600 font-bold">{devis?.numero_devis ?? "—"}</span>
        </h2>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Méthode de calcul :</label>
          <div className="flex gap-3">
            <label>
              <input type="radio" name="mode" value="percent" checked={mode === "percent"} onChange={() => setMode("percent")} /> %
            </label>
            <label>
              <input type="radio" name="mode" value="ht" checked={mode === "ht"} onChange={() => setMode("ht")} /> Montant HT
            </label>
            <label>
              <input type="radio" name="mode" value="ttc" checked={mode === "ttc"} onChange={() => setMode("ttc")} /> Montant TTC
            </label>
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            {mode === "percent" ? "Pourcentage à facturer (%)" : "Montant € à facturer"}
          </label>
          <input
            type="number"
            className="border border-gray-300 rounded px-3 py-1 w-full"
            placeholder={mode === "percent" ? "Ex: 30" : "Ex: 500.00"}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            min="0"
          />
        </div>

        {(totalHT != null || totalTTC != null) && (
          <div className="text-xs text-gray-600 mb-4 space-x-4">
            {totalHT != null && <span>Total devis HT : <strong>{Number(totalHT).toFixed(2)} €</strong></span>}
            {totalTTC != null && <span>Total devis TTC : <strong>{Number(totalTTC).toFixed(2)} €</strong></span>}
          </div>
        )}

        <div className="flex justify-end gap-2">
          <BoutonOnglet onClick={handleAnnuler}>Annuler</BoutonOnglet>
          <BoutonOnglet onClick={handleSubmit}>Valider</BoutonOnglet>
        </div>
      </div>
    </div>
  );
};

export default ModalPartielle;
